"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentfulEntries = void 0;
const tracker_1 = require("../utils/tracker");
const getContentfulEntries = async ({ client, contentType, slug, locale, space, trackingApplicationName }) => {
    const response = await client
        .getEntries({
        content_type: contentType,
        locale,
        'fields.slug': slug,
        limit: 1000,
        include: 10
    })
        .catch((error) => {
        throw new Error(`error in fetching page content, ${error}`);
    });
    void (0, tracker_1.trackData)(response, trackingApplicationName, space !== null && space !== void 0 ? space : '');
    return response;
};
exports.getContentfulEntries = getContentfulEntries;
//# sourceMappingURL=getContentfulEntries.js.map